__turbopack_context__.v({
  "alert": "site-scope-auth-modal-module-scss-module__mmsLyq__alert",
  "alert-error": "site-scope-auth-modal-module-scss-module__mmsLyq__alert-error",
  "btn": "site-scope-auth-modal-module-scss-module__mmsLyq__btn",
  "btn-primary": "site-scope-auth-modal-module-scss-module__mmsLyq__btn-primary",
  "btn-secondary": "site-scope-auth-modal-module-scss-module__mmsLyq__btn-secondary",
  "form-actions": "site-scope-auth-modal-module-scss-module__mmsLyq__form-actions",
  "form-control": "site-scope-auth-modal-module-scss-module__mmsLyq__form-control",
  "form-group": "site-scope-auth-modal-module-scss-module__mmsLyq__form-group",
  "site-scope-auth-form": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-form",
  "site-scope-auth-modal": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-modal",
  "site-scope-auth-modal-overlay": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-modal-overlay",
  "site-scope-auth-modal__close": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-modal__close",
  "site-scope-auth-modal__content": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-modal__content",
  "site-scope-auth-modal__header": "site-scope-auth-modal-module-scss-module__mmsLyq__site-scope-auth-modal__header",
});
